import { ref } from 'vue';
import { debounce } from '@/utils/api';
import { useFlowNavSwiper } from './useFlowNavSwiper';

/**
 * 布局计算功能
 * 包含菜单分组计算和更新帧管理
 */
export const useFrameLayout = centralDispatcher => {
	const { calcSwiperRectWithShadowNodes, splitStringsIntoChunksWithPadding } = useFlowNavSwiper();

	const composeMenus = ref([]);
	const getComposeMenus = () => composeMenus.value;

	const calcSwiperMenu = () => {
		// 通过派发器获取数据，避免参数传递
		const { currentMenus } = centralDispatcher.getState();
		const { nodesMap, layoutOptions } = centralDispatcher.getConfig();
		const { menuItemMargin = 40 } = layoutOptions;

		const additionWidth = calcSwiperRectWithShadowNodes({
			menus: currentMenus,
			shadowNodeClassName: nodesMap.shadowItem
		});
		composeMenus.value = splitStringsIntoChunksWithPadding({
			menus: additionWidth,
			wrapperNodeClassName: nodesMap.swiperWrapper,
			menuItemMargin
		});
	};

	// 支持多个更新帧函数注入
	const updateFrame = debounce((tasks = []) => {
		tasks.forEach(task => {
			task?.();
		});
	}, 300);

	return {
		composeMenus,
		calcSwiperMenu,
		updateFrame,
		getComposeMenus
	};
};
